import React from 'react'
import { useTranslation } from 'react-i18next'
import { useReactiveVar } from '@apollo/client'
import { BuildingFragment } from '../../../generated/graphql'
import { calculatorVar } from '../../../apollo/reactive-vars'
import { SystemContainerCharts } from '../../system-container/SystemContainerCharts'
import { EnergyType } from '../../../calculators/EnergyFlow'

type Props = {
  building?: BuildingFragment
  energyType: EnergyType
}

export function BuildingEnergySystemCharts({
  building,
  energyType,
}: Props): React.ReactElement {
  const { t } = useTranslation()
  const calculator = useReactiveVar(calculatorVar)

  const buildingCalculator = calculator?.findBuilding(building?.id ?? '')
  if (!buildingCalculator) {
    return <></>
  }

  return (
    <SystemContainerCharts
      title={t(`building.tabs.energySystem.chartsByEnergyType.${energyType}`)}
      chartTitlePrefix={t(
        `building.tabs.energySystem.providedByEnergyType.${energyType}`,
      )}
      providers={buildingCalculator.getProviders()}
      energyTypes={[energyType]}
    />
  )
}
